import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BaseUrl from "./Baseurl/Api.js";
import { FaArrowRight } from "react-icons/fa";

import desktopImage from "../image/dharajbanner.jpg";
import defaultProfile from  "../image/dharajbanner.jpg"; // add a default image in your folder

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  const navigate = useNavigate();

  useEffect(() => {
    BaseUrl.get("/api/get_blog")
      .then((response) => {
        if (response.data.status === "success") setBlogs(response.data.Blog);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const indexOfLast = currentPage * blogsPerPage;
  const indexOfFirst = indexOfLast - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const nextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const prevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  const handleArrowClick = (id) => navigate(`/BlogDetails/${id}`);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const date = new Date(dateString);
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  return (
    <>
      <style>{`
        .blog-hero {
          background-size: cover;
          background-position: center;
          min-height: 420px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
        }
        .blog-hero-overlay {
          background: rgba(0, 0, 0, 0.5);
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .blog-hero h1 {
          font-size: 3rem;
          font-weight: 700;
          z-index: 2;
        }
        .blog-card {
          border-radius: 20px;
          overflow: hidden;
          background: rgba(255,255,255,0.05);
          backdrop-filter: blur(15px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.1);
          position: relative;
          cursor: pointer;
          transition: transform 0.4s ease, box-shadow 0.4s ease;
        }
        .blog-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 25px 40px rgba(0,0,0,0.25);
        }
        .blog-img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        .blog-card:hover .blog-img {
          transform: scale(1.1);
        }
        .arrow-btn {
          position: absolute;
          top: 15px;
          right: 15px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(42, 67, 28, 0.2);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(42, 67, 28, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 20px;
          transform: rotate(-40deg);
          transition: 0.4s;
        }
        .arrow-btn:hover {
          transform: rotate(-1deg);
          box-shadow: 0 8px 20px rgba(42, 67, 28, 0.5);
        }
        .blog-body {
          padding: 20px;
          color: #000;
        }
        .blog-title {
          font-weight: 700;
          font-size: 2.1rem;
          margin-bottom: 10px;
          background: linear-gradient(90deg, #007c40ff, #00D4FF);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .blog-snippet {
          font-size: 1.3rem;
          color: rgba(0,0,0,0.85);
          margin-bottom: 15px;
        }
        .blog-btn,
        .pagination-btn {
          border: none;
          padding: 10px 25px;
          border-radius: 50px;
          font-weight: 500;
          color: #fff;
          background: linear-gradient(90deg, rgba(49, 128, 4, 0.83), rgba(108, 240, 31, 0.79));
          transition: all 0.3s ease;
        }
        .blog-btn:hover,
        .pagination-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 10px 25px rgba(42, 67, 28, 0.5);
        }

        /* Author Footer hover */
        .author-footer {
          transition: background 0.3s ease;
        }
        .author-footer:hover {
          background: rgba(246, 253, 239, 0.7);
        }
      `}</style>

      <section className="blog-hero" style={{ backgroundImage: `url(${desktopImage})` }}>
        <div className="blog-hero-overlay"></div>
        <div className="container position-relative">
          <h1>Explore Our Blogs</h1>
          <p>Discover insights, trends, and stories in modern organic farming.</p>
          {/* <a href="#blog-section">
            <button className="blog-btn mt-3">Learn More</button>
          </a> */}
        </div>
      </section>

      <div className="container mt-5 pb-5" id="blog-section">
        <div className="row g-4">

          {/* Skeleton Loader */}
          {loading &&
            [...Array(6)].map((_, i) => (
              <div key={i} className="col-lg-4 col-md-6 col-sm-12">
                <div className="blog-card">
                  <div style={{ height: "240px", background: "#eee" }}></div>
                  <div className="blog-body">
                    <div style={{ width: "70%", height: "20px", background: "#eee" }} className="mb-2"></div>
                    <div style={{ width: "90%", height: "14px", background: "#eee" }} className="mb-2"></div>
                    <div style={{ width: "60%", height: "14px", background: "#eee" }}></div>
                  </div>
                </div>
              </div>
            ))}

          {/* Blogs */}
          {!loading &&
            currentBlogs.map((blog) => (
              <div key={blog.id} className="col-lg-4 col-md-6 col-sm-12">
                <div className="blog-card">

                  {/* Image */}
                  <div className="position-relative">
                    <img
                      src={`${BaseUrl.defaults.baseURL}/blogimage/${blog.blogimage}`}
                      alt={blog.blogtitle}
                      className="blog-img"
                    />

                    <div className="arrow-btn" onClick={() => handleArrowClick(blog.id)}>
                      <FaArrowRight />
                    </div>
                  </div>

                  {/* Body */}
                  <div className="blog-body">
                    <h5 className="blog-title">{blog.blogtitle}</h5>
                    <p className="blog-snippet">
                      {blog.blogdetail.length > 145
                        ? blog.blogdetail.slice(0, 145) + "..."
                        : blog.blogdetail}
                    </p>
                    <Link to={`/BlogDetails/${blog.id}`}>
                      <button className="blog-btn">Read More</button>
                    </Link>
                  </div>

                  {/* ⭐ Author Footer */}
                  <div className="author-footer card-footer bg-white d-flex align-items-center p-3 border-0">
                    <img
                      src={
                        blog.ownerimage
                          ? `${BaseUrl.defaults.baseURL}/blogimage/${blog.ownerimage}`
                          : defaultProfile
                      }
                      alt="Author"
                      className="rounded-circle me-3"
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        border: "2px solid #198754",
                      }}
                    />
                    <div>
                      <p className="mb-0 fw-semibold text-dark">{blog.ownername || "Unknown Author"}</p>
                      <small className="text-muted">{formatDate(blog.blogdate)}</small>
                    </div>
                  </div>

                </div>
              </div>
            ))}
        </div>

        {/* Pagination */}
       {!loading && blogs.length > 0 && (
          <div className="d-flex justify-content-center gap-3 mt-5">
            <button className="pagination-btn" onClick={prevPage} disabled={currentPage === 1}>
              ◀ Previous
            </button>
            <button
              className="pagination-btn"
              onClick={nextPage}
              disabled={currentPage === totalPages}
            >
              Next ▶
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Blog;
